import React, { useState } from 'react';

const ConsultationModal = ({ isOpen, onClose, initialProduct = '' }) => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    product: initialProduct || 'Custom Enterprise Software',
    date: '',
    notes: '',
  });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 3000,
        background: 'rgba(6, 8, 22, 0.9)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
      }}
    >
      <div
        className="glass-card"
        style={{
          maxWidth: '600px',
          width: '100%',
          padding: '28px',
          borderRadius: '28px',
          position: 'relative',
          border: '1px solid rgba(108, 99, 255, 0.4)',
          boxShadow: '0 25px 60px rgba(0, 0, 0, 0.8), 0 0 40px rgba(108, 99, 255, 0.3)',
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '24px',
            right: '24px',
            background: 'rgba(255, 255, 255, 0.08)',
            border: 'none',
            color: '#FFFFFF',
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            cursor: 'pointer',
            fontSize: '1rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <i className="fas fa-times"></i>
        </button>

        {submitted ? (
          <div style={{ textAlign: 'center', padding: '30px 10px' }}>
            <div
              style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                background: 'rgba(16, 185, 129, 0.2)',
                color: '#10B981',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
                margin: '0 auto 20px auto',
              }}
            >
              <i className="fas fa-calendar-check"></i>
            </div>
            <h3 style={{ fontSize: '1.8rem', color: '#FFF', fontWeight: 800, marginBottom: '10px' }}>
              Consultation Scheduled!
            </h3>
            <p style={{ color: '#A3A8B8', fontSize: '1rem', lineHeight: 1.6, marginBottom: '24px' }}>
              Thank you <strong>{formData.name}</strong>. An enterprise solution architect will confirm your calendar invitation at <strong>{formData.email}</strong>.
            </p>
            <button onClick={onClose} className="btn-primary-gradient" style={{ width: '100%' }}>
              Close Window
            </button>
          </div>
        ) : (
          <div>
            <div className="glass-badge" style={{ marginBottom: '16px' }}>
              <span className="pulse-dot"></span>
              <span>HUNGRY TOP CONSULTATION</span>
            </div>

            <h3 style={{ fontSize: '1.8rem', color: '#FFF', fontWeight: 800, marginBottom: '6px' }}>
              Book an Enterprise Consultation
            </h3>
            <p style={{ color: '#A3A8B8', fontSize: '0.92rem', marginBottom: '28px' }}>
              Schedule a 30-minute discovery call with our senior software & AI architects.
            </p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#A3A8B8', marginBottom: '6px' }}>Your Name *</label>
                  <input
                    type="text"
                    required
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#A3A8B8', marginBottom: '6px' }}>Work Email *</label>
                  <input
                    type="email"
                    required
                    placeholder="john@company.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#A3A8B8', marginBottom: '6px' }}>Phone Number</label>
                  <input
                    type="tel"
                    placeholder="+1 (555) 000-0000"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.12)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: '0.8rem', color: '#A3A8B8', marginBottom: '6px' }}>Primary Interest</label>
                  <select
                    value={formData.product}
                    onChange={(e) => setFormData({ ...formData, product: e.target.value })}
                    style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: '#0F172A', border: '1px solid rgba(255,255,255,0.12)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                  >
                    <option value="Custom Enterprise Software">Custom Enterprise Software</option>
                    <option value="PaperLoan Digital Lending">PaperLoan Digital Lending</option>
                    <option value="HungryTop Restaurant Commerce">HungryTop Restaurant Commerce</option>
                    <option value="AI & Machine Learning Solutions">AI & Machine Learning Solutions</option>
                    <option value="Cloud Migration & Security">Cloud Migration & Security</option>
                  </select>
                </div>
              </div>

              <div>
                <label style={{ display: 'block', fontSize: '0.8rem', color: '#A3A8B8', marginBottom: '6px' }}>Preferred Date & Time</label>
                <input
                  type="datetime-local"
                  value={formData.date}
                  onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                  style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', background: '#0F172A', border: '1px solid rgba(255,255,255,0.12)', color: '#FFF', fontSize: '0.9rem', outline: 'none' }}
                />
              </div>

              <button type="submit" className="btn-glow-cyan" style={{ width: '100%', padding: '14px', marginTop: '8px' }}>
                Confirm Consultation Booking
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultationModal;


